import matchSorter from 'match-sorter';
import { Row } from 'react-table';

/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
// @ts-ignore
type GetValue<D> = (row: Row<D>) => string;

/**
 * @typedef {CreateFuzzyTextFilterInput}
 * @property {string[]} keys tells the sorter which values in the data object to use for ranking
 * @property {boolean} autoRemove when true, the table can remove the filter if the string is empty
 */
interface CreateFuzzyTextFilterInput<D> {
    keys: (string | GetValue<D>)[];
    autoRemove?: boolean;
}

/**
 * Returns a filter function that provides fuzzy text matching for react-table, based on the
 * provided `keys` array. See match-sorter docs: https://github.com/kentcdodds/match-sorter#keys-string
 * @param input {CreateFuzzyTextFilterInput}
 * @returns - {@link TableFilter} a filter function for use with react-table
 */
export function createFuzzyTextFilter<D extends Record<string, unknown>>({
    keys,
    autoRemove = true,
}: CreateFuzzyTextFilterInput<D>): TableFilter<D> {
    function newFilter(
        rows: Row<D>[],
        ids: string[],
        filterValue: string,
    ): Row<D>[] {
        return matchSorter(rows, filterValue, {
            keys,
            threshold: matchSorter.rankings.CONTAINS,
        });
    }

    if (autoRemove) {
        // Let the table remove the filter if the string is empty.
        newFilter.autoRemove = (value: string): boolean => !value;
    }

    return newFilter;
}
